<template>
  <header class="header-global">
    <div style="position: absolute;right: 20px;top: 15px;" class="d-block d-lg-none">
      <a :href="dataHead.DOWNLOAD.url" class="btn btn-neutral btn-icon"
         target="_blank" :title="dataHead.DOWNLOAD.title">
                <span class="btn-inner-icon">
                  <i class="fa fa-cloud-download mr-2"></i>
                </span>
        <span class="nav-link-inner--text" v-html="'Télécharger ' + dataHead.brandShort"></span>
      </a>
    </div>
    <base-nav class="navbar-main" effect="light" expand transparent type="">
      <router-link class="navbar-brand mr-lg-5" slot="brand" to="/">
        <h1 class="d-none d-sm-block" style="color: white;font-family: 'Courier New'"
            v-html="dataHead.brand"></h1>
        <h1 class="d-block d-sm-none" style="color: white;font-family: 'Courier New'"
            v-html="dataHead.brandShort"></h1>
      </router-link>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li :title="dataHead.DOWNLOAD.title"
            class="nav-item ml-lg-4">
          <a :href="dataHead.DOWNLOAD.url" class="btn btn-neutral btn-icon"
             target="_blank">
                <span class="btn-inner-icon">
                  <i class="fa fa-cloud-download mr-2"></i>
                </span>
            <span class="nav-link-inner--text" v-html="'Télécharger ' + dataHead.brandShort"></span>
          </a>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";

export default {
  components: {
    BaseNav,
  },
  props: {
    dataHead: {
      type: Object,
      required: true
    }
  },
  methods: {
    downloadPdf() {
      this.$root.$emit('downloadPdf');
    }
  }
};
</script>
<style>
</style>
